import { MapContainer, Marker, Popup, TileLayer,ZoomControl, LayersControl,useMap, useMapEvents, GeoJSON } from 'react-leaflet'
import React, { useState,useRef,useEffect, forwardRef, useImperativeHandle } from 'react'
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
import { icon,icon_new_data } from '../custom_icon';
import "react-leaflet-markercluster/dist/styles.min.css";
import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch'
import "leaflet-geosearch/dist/geosearch.css";
import './MapComponent.css';
import {useNavigate} from 'react-router-dom';


import { toast } from 'react-toastify';
import { LatLngBounds } from "leaflet";
import axios from 'axios';
import jwtDecode from 'jwt-decode';


function LeafletgeoSearch() {
  const map = useMap();
  useEffect(() => {
    const provider = new OpenStreetMapProvider();
    const searchControl = new GeoSearchControl({
      provider,
      marker: {
        icon
      }
    });
    map.addControl(searchControl);
    return () => map.removeControl(searchControl)
  }, []);
  return null;
}


export const MapComponent_sw = forwardRef(({ addMarker,mapClickActive,onSendCoordinate }, ref) => {

  axios.defaults.headers.common["Authorization"] =`Bearer ${localStorage.getItem("token")}`;

  const mapRef = useRef();
  const inputRef = useRef(null);
  const [markers, setMarkers] = useState(null);
  const [manualMarks, setManualMarks] = useState([]);
  const [mapCenter, setMapCenter] = useState([44.36, 11.34]);

  const [coordinates, setCoordinates] = useState({ lat: '', lng: '' });

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [geojsonFiles, setGeojsonFiles] = useState([]);

  const [username, setUsername] = useState(null);

  const [openOverlayIndex, setOpenOverlayIndex] = useState(null);

  const [markerPosition, setMarkerPosition] = useState(null); // null iniziale


  const handleMapClick = (e) => {
    if (!mapClickActive) return; // usa sempre la prop aggiornata
    const { lat, lng } = e.latlng;
    setManualMarks(prev => [...prev, { lat, lng }]);
    setMapCenter([lat, lng]);
    mapRef.current?.setView([lat, lng]);
  };

  const addMapClickListener = (map) => {
    mapRef.current = map;
  };

  // Riaggancia il click listener ogni volta che mapClickActive cambia
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    // rimuovi vecchio listener prima di aggiungerne uno nuovo
    map.off('click', handleMapClick);
    map.on('click', handleMapClick);

    return () => {
      map.off('click', handleMapClick);
    };
  }, [mapClickActive]);

  const [uploadProgress, setUploadProgress] = useState(0);


  // Use this effect to attach the listener after the map is created
  useEffect(() => {
    const map = mapRef.current;
    if (map) {
      map.on('click', handleMapClick);
    }
    return () => {
      if (map) {
        map.off('click', handleMapClick);
      }
    };
  }, [mapRef.current]);

     // Quando clicchi sul marker, aggiorniamo le coordinate
      const handleMarkerClick = (lat, lng) => {
        setCoordinates({ lat, lng });
      };

      // Submit del form nel popup
      const handleSubmit = (event) => {
        event.preventDefault();
        if (!coordinates.lat || !coordinates.lng) {
          alert("Seleziona prima un marker!");
          return;
        }
        if (onSendCoordinate) {
          onSendCoordinate(`${coordinates.lat}, ${coordinates.lng}`);
        }
      };

  const handleAddMarker = () => {
            const inputCoordinates = inputRef.current.value.split(",");
            if (inputCoordinates.length === 2) {
               const [lat, lng] = inputCoordinates.map((coord) => parseFloat(coord));
            if (!isNaN(lat) && !isNaN(lng)) {
                    setManualMarks({ lat, lng });
                    setMapCenter([lat, lng]);
                    const map = mapRef.current;
                    if (map) {
                    map.setView([lat, lng]);
                      }
                    }
      };}

  // Function to remove a marker on double-click
      const handleMarkerDoubleClick = (index) => {
            setManualMarks((prevMarks) => prevMarks.filter((_, i) => i !== index));
      };


    useImperativeHandle(ref, () => ({
        handleProjectChange,
        getProjects: () => projects,

        fetchProjects: async () => {
            try {
                const response = await axios.get(
                    "https://hat.sofhare.com/user-projects/"
                );

                const projectsData = response.data.projects;

                setProjects(Object.keys(projectsData));
                setGeojsonFiles(projectsData);

                return Object.keys(projectsData);

            } catch (err) {
                console.error("Errore caricamento progetti:", err);
                return [];
            }
        }
    }));

        useEffect(() => {
            if (!selectedProject || !geojsonFiles[selectedProject]) return;

            const geojsonFilesForProject = geojsonFiles[selectedProject];

            const loadMarkers = async () => {
            const allNewMarkers = await Promise.all(
                geojsonFiles[selectedProject].map(async (file) => {
                    try {
                        const response = await axios.get(
                            `https://hat.sofhare.com/user-photo-link/${selectedProject}/${file.properties.photo}`,
                            {
                                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
                            }
                        );

                        return {
                            lat: file.coordinates[1],
                            lng: file.coordinates[0],
                            name: file.properties.name,
                            type: file.properties.type,
                            photo: response.data.photo_url
                        };
                    } catch (err) {
                        // Log completo dell’errore
                        console.error("Errore caricando la foto:", file.properties.photo);
                        if (err.response) {
                            // La richiesta è stata fatta e il server ha risposto con status != 2xx
                            console.error("Status:", err.response.status);
                            console.error("Response data:", err.response.data);
                            console.error("Response headers:", err.response.headers);
                        } else if (err.request) {
                            // La richiesta è stata fatta ma non è arrivata risposta
                            console.error("Request fatta ma nessuna risposta:", err.request);
                        } else {
                            // Qualche altro errore
                            console.error("Errore configurazione axios:", err.message);
                        }
                        return {
                            lat: file.coordinates[1],
                            lng: file.coordinates[0],
                            name: file.properties.name,
                            type: file.properties.type,
                            photo: null
                        };
                    }
                })
            );

            setMarkers(allNewMarkers);

            if (allNewMarkers.length > 0 && mapRef.current) {
                mapRef.current.setView([allNewMarkers[0].lat, allNewMarkers[0].lng], 10);
            }
        };

            loadMarkers();
        }, [selectedProject, geojsonFiles]);

        // Tua funzione originale rimane esattamente così
        const handleProjectChange = (e) => {
            const projectName = e.target.value;

            setSelectedProject(projectName);
            setMarkers([]); // cancella i marker prima del nuovo effetto
        };



 return (
        <div className="general">
            <div className="mapsw" style={{ position: 'relative' }}>

            <a href="/#" id="downloadAnchorElem" style={{ display:"none" }} >a</a>
                <MapContainer  center={mapCenter} zoom={10} zoomControl={false} whenCreated={addMapClickListener} style={{ height: '100%', width: '100%',borderRadius: '7px'}}>
                    <LayersControl position="topright">
                        <LayersControl.BaseLayer checked name="OpenStreetMap.HOT">
                          <TileLayer
                            url='https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
                          />
                        </LayersControl.BaseLayer>

                        <LayersControl.BaseLayer unchecked name="Satellite ESRI">
                            <TileLayer
                                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                                attribution='Map Tiles © 2022 Esri, Maxar, Earthstar Geographics, CNES/Airbus DS, USDA FSA, USGS,Getmapping, Aerogrid, IGN, IGP, and the GIS User Community'
                            />
                        </LayersControl.BaseLayer>
                      </LayersControl>
                    <ZoomControl position='topleft'/>

                   <LeafletgeoSearch />

                   {/* Render the markers */}
                    {markers && markers.map((marker, index) => (
                        <Marker
                            key={index}
                            position={[marker.lat, marker.lng]}
                            icon={icon_new_data}
                            eventHandlers={{
                                click: (e) => { // Add the click event handler to the marker

                                    handleMarkerClick(marker.lat, marker.lng, index); // Handle marker click
                                }
                            }}
                        >
                            <Popup>
                                <div>
                                    <div className="form_data">
                                        <form className="contact-form" onSubmit={handleSubmit}>
                                            <input
                                                type="text"
                                                id="tipo_prova"
                                                name="tipo_prova"
                                                defaultValue={marker.name}
                                                required
                                                readOnly
                                            />
                                            <br/>
                                            <input
                                                type="text"
                                                value={coordinates.lat && coordinates.lng ? `${coordinates.lat}, ${coordinates.lng}` : ""}
                                                readOnly
                                              />
                                            <br/>
                                            {marker.photo && (
                                              <span style={{
                                                fontSize: '16px',
                                                lineHeight: '13px',
                                                color: '#0066cc',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                              }}>
                                                <a
                                                  href={marker.photo}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{ color: '#12e3e3', textDecoration: 'none' }}
                                                >
                                                  Apri foto
                                                </a>
                                              </span>
                                            )}
                                            <br />
                                            <br/>
                                            <input
                                                type="hidden"
                                                name="photo_url"
                                                value={marker.photo}
                                            />
                                            <input
                                                type="submit"
                                                value="Prendi coordinate"
                                            />
                                        </form>
                                    </div>
                                </div>
                            </Popup>
                        </Marker>
                   ))}

        
                   {/* Render the manual markers */}
                   {manualMarks.length > 0 && manualMarks.map((marker, index) => ( // Use index2 for manual markers
                        <Marker
                            key={`manual-${index}`} // Use index2 for unique key
                            position={[marker.lat, marker.lng]}
                            icon={icon_new_data}
                            eventHandlers={{
                                dblclick: () => handleMarkerDoubleClick(index), // Use index2
                                click: (e) => { // Handle marker click
                                    //e.preventDefault(); // Prevent default behavior to avoid unintended actions
                                    handleMarkerClick(marker.lat, marker.lng, index); // Use index2 here as well
                                }
                            }}
                        >
                            <Popup>
                                <div>
                                    <h3>Nuova prova</h3>
                                    <div className="form_data">
                                        <form className="contact-form" onSubmit={handleSubmit}>
                                            <br />
                                            <input
                                                type="text"
                                                value={coordinates.lat && coordinates.lng ? `${coordinates.lat}, ${coordinates.lng}` : ""}
                                                readOnly
                                              />
                                            <br />
                                            <input
                                                type="submit"
                                                value="Prendi coordinate"
                                            />
                                        </form>
                                    </div>
                                </div>
                            </Popup>
                        </Marker>
                   ))}
                </MapContainer>

            </div>

        </div>

  )

});
